import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../config/firebase';
import { toast } from 'react-toastify';
import emailService from './emailService';
import { getFunctions, httpsCallable } from 'firebase/functions';
import axios from 'axios';

/**
 * Handle partner registration and ensure welcome email is sent
 * @param {Object} formData The partner registration data
 * @returns {Promise<{success: boolean, partnerId?: string, error?: string}>}
 */
export const registerPartner = async (formData) => {
  try {
    console.log("Đang lưu dữ liệu đối tác...");
    
    // Lưu dữ liệu vào Firestore
    const partnerRef = collection(db, "partners");
    const partnerData = {
      ...formData,
      createdAt: serverTimestamp(),
    };
    const docRef = await addDoc(partnerRef, partnerData);
    const partnerId = docRef.id;
    
    console.log("Partner registered with ID:", partnerId);
    
    let emailSent = false;
    
    // Gửi email chào mừng thông qua Cloud Function
    if (formData.email && formData.businessName) {
      console.log("Gửi email chào mừng cho:", formData.email);
      
      try {
        // Thử gọi Cloud Function sendWelcomeEmail
        const functions = getFunctions();
        // Cấu hình region cho functions
        const functionsWithRegion = getFunctions(undefined, 'us-central1');
        const sendWelcomeEmailFunction = httpsCallable(functionsWithRegion, 'sendWelcomeEmail');
        
        console.log("Gọi Cloud Function với dữ liệu:", {
          email: formData.email,
          businessName: formData.businessName
        });
        
        const result = await sendWelcomeEmailFunction({
          email: formData.email,
          businessName: formData.businessName
        });
        
        console.log("Kết quả từ Cloud Function:", result);
        
        const data = result.data;
        if (data && data.success) {
          console.log("Email gửi thành công qua Cloud Function");
          emailSent = true;
        } else {
          console.error("Cloud Function không trả về success=true:", data);
        }
      } catch (cloudFunctionError) {
        console.error("Lỗi khi gọi Cloud Function:", cloudFunctionError);
      }
      
      // Nếu Cloud Function thất bại, gửi email trực tiếp
      if (!emailSent) {
        try {
          console.log("Gửi email trực tiếp vì Cloud Function thất bại");
          
          // Thay vì sử dụng window.location (không hoạt động ổn định trên tất cả môi trường)
          // Kiểm tra nếu đang ở môi trường phát triển dựa trên URL
          const isLocalhost = typeof window !== 'undefined' && 
            (window.location.hostname === 'localhost' || 
             window.location.hostname === '127.0.0.1');
          
          if (!isLocalhost) {
            // Đã thử Cloud Function ở trên và thất bại, thử gọi function khác
            console.log("Thử gọi cloud function khác");
            
            // Sử dụng functions region correct
            const functionsRegion = getFunctions(undefined, 'us-central1');
            const sendPartnerRegistrationNotificationFunction = httpsCallable(
              functionsRegion, 
              'sendPartnerRegistrationNotification'
            );
            
            const notificationResult = await sendPartnerRegistrationNotificationFunction({
              email: formData.email,
              businessName: formData.businessName
            });
            
            console.log("Kết quả gửi thông báo:", notificationResult);
            toast.success(`Đăng ký thành công! Chúng tôi sẽ liên hệ với bạn trong thời gian sớm nhất.`);
            emailSent = true;
          } else {
            // Trong môi trường cục bộ, gọi API localhost
            const apiUrl = 'http://localhost:3001/api/send-welcome-email';
            await axios.post(apiUrl, {
              email: formData.email,
              businessName: formData.businessName
            });
            console.log("Email gửi thành công thông qua local API");
          }
          
          // Đánh dấu email đã được xử lý
          emailSent = true;
        } catch (directEmailError) {
          console.error("Lỗi khi gửi email trực tiếp:", directEmailError);
          
          // Hiển thị thông báo cho admin để gửi email thủ công
          toast.warning(`Không thể gửi email tự động cho ${formData.businessName}. Vui lòng kiểm tra và gửi thủ công.`);
        }
      }
    }
    
    toast.success("Đăng ký đối tác thành công!");
    
    // Trả về kết quả thành công
    return {
      success: true,
      partnerId,
      emailSent
    };
  } catch (error) {
    console.error("Error during registration:", error);
    toast.error("Có lỗi xảy ra trong quá trình đăng ký. Vui lòng thử lại sau.");
    
    return {
      success: false,
      error: error.message
    };
  }
}; 